import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const LoadMoreProjects = (props) => {

  let text_show = 'Toon meer projecten'
  let text_showing = `${props.nrShowing} van de ${props.nrAll} getoond`

  if (props.language == 'en') {
    text_show = 'Show more projects'
    text_showing = `${props.nrShowing} of ${props.nrAll} showing`
  }

  function handleLoadMore(e) {
    e.preventDefault()
    props.onLoadMore()
  }

  if (props.loading) {
    return null
    // we already return a loader in Projects.js
  }

  if (props.nrShowing >= props.nrAll) {
    return null
    // we have loaded all posts
  }

  return (
    <div className="c-projects-load-more">
      <a href="#" onClick={handleLoadMore} className="c-projects-load-more__link">

        <div className="c-projects-load-more__title">
          {text_show}
          <svg class="c-icon c-icon--small c-project__icon">
            <use href="#arrow-thin-down" xlinkHref="#arrow-thin-down"></use>
          </svg>
        </div>

        <div className="c-projects-load-more__subtitle">{text_showing}</div>
      </a>
    </div>
  )
}

export default LoadMoreProjects



// WEBPACK FOOTER //
// ./src/js/projects/components/LoadMoreProjects.js